import { EventEmitter, Injectable, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@aspnet/signalr';
import {fuelTypeData } from '../Models/IsoModels';
import { environment } from '../../environments/environment';
import { lmpTblRow, loadTblRow } from '../Models/IsoModels';
import { MeterData, gridMeter } from '../Models/MeterModel';
import {psegLoadsTbl, pseghrlyLoadsTbl } from '../Models/LoadsData';
import {rtoLoadsTbl, rtohrlyLoadsTbl } from '../Models/LoadsData';

@Injectable()
export class SignalrISOdataService implements OnInit  {
  connectionEstablished = new EventEmitter<Boolean>();

  LMPmessageReceived = new EventEmitter<lmpTblRow>();

  LoadmessageReceived = new EventEmitter<loadTblRow>();

  GenmixmessageReceived = new EventEmitter<fuelTypeData>();

  PsegLoadsRefreshMessageReceived = new EventEmitter<Array<psegLoadsTbl>>();
  PsegHrlyLoadsRefreshMessageReceived = new EventEmitter<Array<pseghrlyLoadsTbl>>();

  RtoLoadsRefreshMessageReceived = new EventEmitter<Array<rtoLoadsTbl>>();
  RtoHrlyLoadsRefreshMessageReceived = new EventEmitter<Array<rtohrlyLoadsTbl>>();
 
  public connectionIsEstablished = false;
  public _hubConnection: HubConnection;


  constructor() {
    this.createConnection();
    this.registerOnServerEvents();
    this.startConnection();
  }

  private createConnection() {
    this._hubConnection = new HubConnectionBuilder()
      .withUrl(environment.hubUrl)
      .build();
      this._hubConnection.serverTimeoutInMilliseconds = 100000000; // 100000 second
  }
 
  private startConnection(): any {
    this._hubConnection
      .start()
      .then(() => {
        this.connectionIsEstablished = true;
        console.log('Hub connection started');
        this.connectionEstablished.emit(true);
      })
      .catch(err => {
        console.log('Error while establishing connection, retrying...');
        setTimeout(this.startConnection(), 5000);
      });
  }

  private registerOnServerEvents(): void {
    this._hubConnection.on('ReceiveLMP', (data: any) => {
      this.LMPmessageReceived.emit(data);
    });
    this._hubConnection.on('ReceiveLoad', (data: any) => {
      this.LoadmessageReceived.emit(data);
    });

    this._hubConnection.on('ReceiveGenmix', (data: any) => {
      this.GenmixmessageReceived.emit(data);
    });
    this._hubConnection.on('PsegLoadsRefreshMessageReceived', (data: any) => {
      this.PsegLoadsRefreshMessageReceived.emit(data);
    });
    this._hubConnection.on('PsegHrlyLoadsRefreshMessageReceived', (data: any) => {
      this.PsegHrlyLoadsRefreshMessageReceived.emit(data);
    });
    this._hubConnection.on('RtoLoadsRefreshMessageReceived', (data: any) => {
      this.RtoLoadsRefreshMessageReceived.emit(data);
    });
    this._hubConnection.on('RtoHrlyLoadsRefreshMessageReceived', (data: any) => {
      this.RtoHrlyLoadsRefreshMessageReceived.emit(data);
    });
    this._hubConnection.onclose(this. createConnection);


  }
  ngOnInit(): void {

  }

}



